import { GetListParams } from 'react-admin';

import {
  CustomDataProvider,
  registerModuleDataProvider,
} from 'src/pages/admin/providers/CustomDataProvider';
import {
  ListProviderAuditMismatchesResponse,
  getProviderAuditLocks,
  listProviderAuditMismatches,
} from 'src/pages/admin/services/xbitRelayProviderAuditService';

import { Resources } from '../../resource';
import { PROVIDER_AUDIT_LOCKS_RESOURCE } from './constants';
import { lockRowId, paginateLocks, pickLockFilters, pickMismatchFilters } from './helpers';

const resourceName = Resources.xbitRelayProviderAudit;

export const xbitRelayProviderAuditDataProvider: CustomDataProvider = {
  async getList(_resource: string, params: GetListParams): Promise<any> {
    const { page = 1, perPage = 20 } = params.pagination || {};

    const response = await listProviderAuditMismatches({
      ...pickMismatchFilters(params.filter),
      page,
      pageSize: perPage,
    });

    const { items = [], total } =
      response.data ?? ({} as Partial<ListProviderAuditMismatchesResponse>);
    return {
      // `total` is an int64-as-string; react-admin needs a number.
      data: items.map((item) => ({ ...item, id: item.id })),
      total: Number(total) || 0,
    };
  },
};

registerModuleDataProvider(resourceName, xbitRelayProviderAuditDataProvider);

/**
 * `/locks` returns every matching row in one shot with no `total` — page it client-side so the
 * tab still gets the standard `<Pagination>`, and key each row by (user, provider).
 */
export const xbitRelayProviderAuditLocksDataProvider: CustomDataProvider = {
  async getList(_resource: string, params: GetListParams): Promise<any> {
    const { page = 1, perPage = 20 } = params.pagination || {};

    const response = await getProviderAuditLocks(pickLockFilters(params.filter));
    const states = response.data?.states ?? [];
    const rows = states.map((state) => ({ ...state, id: lockRowId(state) }));

    return {
      data: paginateLocks(rows, page, perPage),
      total: rows.length,
    };
  },
};

registerModuleDataProvider(PROVIDER_AUDIT_LOCKS_RESOURCE, xbitRelayProviderAuditLocksDataProvider);
